// extracted by mini-css-extract-plugin
export var currentStep = "_j2-2";
export var nodeCard = "_j2-0";
export var pathHighlighted = "_j2-1";